module.exports = __webpack_public_path__ + "img/1537926150.eea9b397.jpg";